import I18n from 'components/I18n'
import BankIcon from 'components/Icons/Bank'
import InformationIcon from 'components/Icons/Information'
import palette from 'components/palette'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { getSupportLink } from 'services/urlService'

import { Wrapper } from '../../../styles'
import { Button, Description, ImageWrapper, Title } from '../../styles'

type Props = {
  onBack: () => void
} & WrappedComponentProps

const NameMismatch = ({ intl, onBack }: Props) => (
  <Wrapper>
    <ImageWrapper>
      <BankIcon fill={palette.primary} size='72' />
      <InformationIcon fill={palette.orange500} size='32' />
    </ImageWrapper>
    <Title>
      <I18n data={messages.link_bank_error_name_title} />
    </Title>
    <Description>
      <I18n
        data={messages.link_bank_error_name_subtitle}
        link={
          <a href={getSupportLink(intl.locale)} rel='noopener noreferrer' target='_blank'>
            <I18n data={messages.learn_more} />
          </a>
        }
      />
    </Description>
    <Button onClick={onBack}>
      <I18n data={messages.try_different_bank} />
    </Button>
  </Wrapper>
)

export default injectIntl(NameMismatch)
